import Robot from "resources/images/robot.png";
import { cn } from "app/lib/utils";

interface ChatAvatarProps {
  readonly isPrivate?: boolean;
}

/**
 * ChatAvatar component displays the assistant's avatar with a status indicator dot.
 *
 * @param isPrivate - If true, shows green dot (private chat). If false, shows orange dot (public chat).
 */
export default function ChatAvatar({ isPrivate = true }: ChatAvatarProps) {
  return (
    <div className="relative w-11 h-11 rounded-full mr-2.5">
      <img src={Robot} alt="Criteria" className="h-10 mr-2.5" />
      <div
        className={cn(
          "w-3 h-3 rounded-full absolute right-1 bottom-1",
          isPrivate ? "bg-[#00c067]" : "bg-[#ffac19]"
        )}
        aria-label={isPrivate ? "Private conversation" : "Public conversation"}
      />
    </div>
  );
}
